import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

export default ( { loadData, transformResponse } ) => {
  let _listGetter = null;
  let _list = null;
  let _dict = null;

  const loadList = () => {
    if (!_listGetter) {
      _listGetter = loadData()
        .then(( { data } ) => {
          if (transformResponse) return transformResponse(data);
          return data;
        })
        .then(response => {
          _list = response;
          _dict = arrayToIdIndex(response);
          return response;
        });

    }
    return _listGetter;
  };

  const getById = ( id ) => loadList().then(() => _dict[id]);

  const getList = () => loadList().then(() => _list);

  const getDict = () => loadList().then(() => _dict);

  return { getList, getById, getDict };
}
